// useSessionCheck.js
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { sessionManager } from '../context/sessionManager';

export const useSessionCheck = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const checkSession = () => {
      if (!sessionManager.isValidSession()) {
        sessionManager.clearSession();
        localStorage.removeItem("appAuth");
        navigate('/login');
        return false;
      }
      return true;
    };

    // Initial check
    if (!checkSession()) {
      return;
    }

    // Setup auto logout
    sessionManager.setupAutoLogout();

    // Listen for session expiration event
    const handleSessionExpired = () => {
      sessionManager.clearSession();
      localStorage.removeItem("appAuth");
      navigate('/login');
    };

    window.addEventListener('session-expired', handleSessionExpired);

    // Check session periodically (every 30 seconds for better responsiveness)
    const interval = setInterval(checkSession, 30000);

    return () => {
      clearInterval(interval);
      window.removeEventListener('session-expired', handleSessionExpired);
      sessionManager.clearAutoLogout();
    };
  }, [navigate]);
};